<template>
	<div>
		<router-link tag="a" :to="`/e/${event.code}`" class="event-card shadow-bottom">
			<div class="image" v-if="event.image" :style="`background-image:url(${event.image.url})`"></div>
			<div class="data">
				<div class="date">
					<span class="day">{{ event.startAt | moment("DD") }}</span>
					<span class="month">{{ event.startAt | moment("MMM") }}</span>
				</div>
				<div class="flex-grow-1">
					<div class="ml-1">
						<h2>{{ event.name }}</h2>
					</div>
					<div class="data-set" v-if="event.location">
						<i class="icon icon-map-marker"></i>
						<div class="info">
							<h2>{{ event.location.name }}</h2>
							<p>
								{{ event.location.address }},
								<span v-if="event.location.locality">{{ event.location.locality.name }}, </span>
								<span v-if="event.location.locality">{{ event.location.locality.region.name }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
import Layout from "@/components/Layout"

export default {
	name: "EventCard",
	props: {
		event: {
			type: Object,
			required: true
		}
	},
	components: {
		Layout
	},
	data() {
		return {}
	}
}
</script>

<style scoped lang="scss">
.event-card {
	width: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	border-radius: 8px;
	background-color: #fff;

	.image {
		width: 100%;
		padding-bottom: 100%;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.data {
		padding: 18px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		min-height: 120px;

		.date {
			width: 50px;
			flex-shrink: 0;
			display: flex;
			flex-direction: column;
			align-items: center;

			.day {
				font-size: 24px;
				line-height: 18px;
				font-weight: bold;
				color: #000;
			}
			.month {
				font-size: 14px;
				color: #000;
				text-transform: uppercase;
				line-height: 16px;
			}
		}

		h2 {
			font-size: 1.16rem;
			color: #000;
			font-weight: 500;
		}
		.data-set {
			display: flex;
			align-items: flex-start;
			justify-self: start;
			cursor: pointer;

			.icon {
				width: 18px;
				flex-shrink: 0;
				font-size: 1.3rem;
				color: #bbb;
				margin-top: 3px;
				margin-right: 10px;
			}
			.info {
				flex-grow: 1;

				h2 {
					font-size: 1em;
				}
				p {
					font-size: 0.95em;
					color: #666;
					margin: 0px;
				}
			}
		}
	}
}
</style>
